export type TipoDoItemDeIntegracao = 'PRODUTO' | 'PRECO'

export type OperacaoDoItemDeIntegracao = 'CADASTRO' | 'ATUALIZACAO' | 'REGRA_FISCAL' | 'IMAGENS' | 'OUTRA'

export type SituacaoDoItemDeIntegracao = 'PENDENTE' | 'AGUARDANDO' | 'SUCESSO' | 'NOVO_ERRO'

export interface ItemDoPainelDeIntegracao {
	id: string
	dataHoraDoErro: string
	tipo: TipoDoItemDeIntegracao
	operacao: OperacaoDoItemDeIntegracao
	sku?: string | null
	quantidadeDeSkus: number
	ticket: number
	mensagemDeErro: string
	situacao: SituacaoDoItemDeIntegracao
	reenvios: number
}

export interface ItemReenviado {
	itemId: string
	novoItemId: string
	ticket: number
}

export interface ItemRecusadoNoReenvio {
	itemId: string
	motivo: SituacaoDoItemDeIntegracao
}

export type EstadoDasIntegracoes = Partial<Record<TipoDoItemDeIntegracao, { ativo: boolean }>>

export const rotulosDeTipo: Record<TipoDoItemDeIntegracao, string> = {
	PRODUTO: 'Produto',
	PRECO: 'Preço',
}

export const rotulosDeOperacao: Record<OperacaoDoItemDeIntegracao, string> = {
	CADASTRO: 'Cadastro',
	ATUALIZACAO: 'Atualização',
	REGRA_FISCAL: 'Regra fiscal',
	IMAGENS: 'Imagens',
	OUTRA: 'Outra',
}

export const rotulosDeSituacao: Record<SituacaoDoItemDeIntegracao, string> = {
	PENDENTE: 'Pendente',
	AGUARDANDO: 'Reenviado, aguardando',
	SUCESSO: 'Reenviado com sucesso',
	NOVO_ERRO: 'Reenviado com novo erro',
}

export const situacoesQuePermitemReenvio: SituacaoDoItemDeIntegracao[] = [
	'PENDENTE',
	'NOVO_ERRO',
]
